import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentService } from '../environment.service';
import { IGridService } from '../models/igrid-service';
import { DossierResultDto } from '@lexi-clients/lexi';
import { DossierListResult } from '../models/dossier-list';

@Injectable({
  providedIn: 'root'
})
export class DossierListService implements IGridService<DossierResultDto> {

  baseUrl: string;

  constructor(private http: HttpClient, envService: EnvironmentService) {
    this.baseUrl = envService.environment.baseServiceUrl;
  }

  get(params: HttpParams): Observable<DossierListResult> {
    return this.http.get<any>(`${this.baseUrl}/api/Dossiers/recherche-devexpress`, { params : params});
  }

  getById(id: number | string): Observable<DossierResultDto> {
    return this.http.get<any>(`${this.baseUrl}/api/Dossiers/${id}`);
  }

  post(valeur: DossierResultDto): Observable<any> {
    return null;
  }

  put(valeur: DossierResultDto): Observable<any> {
    return null;
  }

  delete(valeur: DossierResultDto): Observable<any> {
    return null;
  }
}
